/* eslint-disable jsx-a11y/label-has-for */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class ImageSelector extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string,
      name: PropTypes.string,
      image: PropTypes.string
    })).isRequired,
    className: PropTypes.string
  };

  static defaultProps = {
    options: [],
    className: '',
  };

  state = {
    selected: ''
  }

  componentDidMount() {
    const { value } = this.props;
    if(value) {
      this.setState({selected: value});
    }
  }

  componentWillReceiveProps (nextProps) {
    const { value } = nextProps;
    if(value) {
      this.setState({selected: value});
    }
  }

  onChange = (event) => {
    console.log(event.target.value);
    this.setState({ selected: event.target.value })
    this.props.onChange(event.target.value);
  };

  render() {

    const { className, name, options } = this.props;

    return options.map(option => {

      const isChecked = option.value === this.state.selected;

      return (
        <div key={option.value} className={["image-selector", isChecked ? "image-selector__checked" : ""].join(" ")}>
          <label
            className={`${className ? ` radio-btn--${className}` : ''}`}
          >
            <input
              className="radio-btn__radio"
              name={name}
              type="radio"
              value={option.value}
              checked={isChecked}
              onChange={this.onChange}
            />
            <img 
              src={option.image} 
              alt={option.name} 
              className={ isChecked ? 'image-selector__checked' : '' }
              />
            <p className={["image-selector__label", isChecked ? "image-selector__label__checked" : ""].join(" ")}>{option.name}</p>
          </label>
        </div>
      )
    });
  }
}

const renderImageSelector = props => (
  <ImageSelector
    {...props.input}
    className={props.className}
    options={props.options}
  />
);

renderImageSelector.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    name: PropTypes.string,
    value: PropTypes.string
  }).isRequired,
  className: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    name: PropTypes.string,
    image: PropTypes.string
  }))
};

renderImageSelector.defaultProps = {
  options: [],
  className: '',
};

export default renderImageSelector;
